import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId:
        "us-east-1:18184049-1532-45a4-b44a-7040c5fd20ef",
      allowGuestAccess: true
    }
  }
});